import Former from "../classes/Former";

class CasesBlock extends Former {
    blockHideableElementSelector = '.case-item';

    elementDataSearchableTypes = {
        text: 'case-searchable',
        type: 'case'
    }

    blockModifiers = {
        expanded: 'block-cases--expanded',
        filtered: 'block-cases--filtered'
    }

    processForm(event: SubmitEvent): any {
        const parentProcess = super.processForm(event);

        /**
         * Generate selectors to hide or display items
         */
        const selectors = this.generateSelectors({
            country: parentProcess.formDataObject.country,
            city: parentProcess.formDataObject.city,
            "asset-type": parentProcess.formDataObject["asset-type"]
        }, {"text-search": parentProcess.formDataObject["text-search"]});
        
        this.toggleItems(selectors);
    }
}

export default CasesBlock;